import rgba from "polished/lib/color/rgba";
import colors from "ui-components/colors";
const sizes = {
  inherit: {
    fontSize: "inherit"
  },
  small: {
    fontSize: "12px",
    fontWeight: 400
  }
};
const flat = {
  default: {
    passive: {
      color: "inherit",
      border: "inherit"
    },
    hover: {
      color: colors.orange,
      border: rgba(colors.orange, 0.5)
    }
  },
  coal: {
    passive: {
      color: colors.coal,
      border: rgba(colors.coal, 0.5)
    },
    hover: {
      color: colors.orange,
      border: rgba(colors.orange, 0.5)
    }
  },
  blue: {
    passive: {
      color: colors.blue,
      border: rgba(colors.blue, 0.5)
    },
    hover: {
      color: colors.orange,
      border: rgba(colors.orange, 0.5)
    }
  },
  grey: {
    passive: {
      color: colors.lighterCoal,
      border: rgba(colors.lighterCoal, 0.5)
    },
    hover: {
      color: colors.orange,
      border: rgba(colors.orange, 0.5)
    }
  },
  white: {
    passive: {
      color: colors.white,
      border: rgba(colors.white, 0.5)
    },
    hover: {
      color: colors.orange,
      border: rgba(colors.orange, 0.5)
    }
  }
};
const themes = {
  flat
};
export { themes, sizes };